import TestimonialSlider from "./TestimonialSlider";

export default TestimonialSlider;
